import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import ContactForm from './ContactForm';

const ContactModal = ({ isOpen, onClose, type = "general", title, description }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const modalContent = {
    general: {
      title: "Contactez-nous",
      description: "Une question ? Un projet ? Nous vous recontactons rapidement."
    },
    rappel: {
      title: "Être rappelé gratuitement",
      description: "Laissez vos coordonnées et nous vous rappelons dans les plus brefs délais."
    },
    conseil: {
      title: "Demande de conseil",
      description: "Nos experts vous accompagnent gratuitement dans votre projet MaPrimeAdapt'."
    }
  };

  const content = modalContent[type] || modalContent.general;

  // Portail vers <body> : posée dans une section « relative z-10 », la fenêtre
  // restait sous l'en-tête « sticky z-50 », qui interceptait le clic sur la croix.
  return createPortal(
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100] p-4"
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="titre-contact"
    >
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header with close button */}
        <div className="flex justify-between items-center p-6 border-b border-gray-300">
          <div>
            <h2 id="titre-contact" className="text-xl font-bold text-gray-900">
              {title || content.title}
            </h2>
          </div>
          <button
            onClick={onClose}
            aria-label="Fermer la fenêtre"
            className="text-gray-500 hover:text-gray-900 transition-colors p-2 hover:bg-gray-100 rounded-full min-h-[44px] min-w-[44px] flex items-center justify-center"
          >
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <ContactForm 
            type={type}
            title=""
            description={description || content.description}
            onClose={onClose}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ContactModal;